/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;width:100%}.selected[_ngcontent-%COMP%]{padding:2px;margin:5px 0}.selected__delete[_ngcontent-%COMP%]{color:#fe3b1f;cursor:pointer}"];
export { styles as styles };
